import { jsx as _jsx } from "react/jsx-runtime";
export const DeviceButton2 = props => {
    const button_class_names = [
        'lw-button'
    ];
    switch (props.state) {
        case 'on':
            button_class_names.push('lw-button-on');
            break;
        case 'off':
            button_class_names.push('lw-button-off');
            break;
        case undefined:
            break;
    }
    const button_class = button_class_names.join(' ');
    return (_jsx("button", { className: button_class, onClick: () => props.onClick(), children: props.children }));
};
